import { Navigate } from 'react-router-dom';
import React from 'react';

const ProtectedRoute = ({ children }) => {
    let loggedIn = localStorage.getItem('loggedIn');
    // console.log(loggedIn);

    return (
        loggedIn === 'true' ? children : <Navigate to='/login'></Navigate>
    );
}

export default ProtectedRoute;